import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const RTLContext = createContext({
  isRTL: false,
  direction: "ltr",
});

const RTLProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [isRTL, setIsRTL] = useState(i18n.dir() === "rtl");
  const [direction, setDirection] = useState(i18n.dir());

  useEffect(() => {
    const handleLanguageChange = () => {
      const dir = i18n.dir();
      setIsRTL(dir === "rtl");
      setDirection(dir);
    };

    // Set initial values
    handleLanguageChange();

    // Listen for language changes
    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return (
    <RTLContext.Provider value={{ isRTL, direction }}>
      {children}
    </RTLContext.Provider>
  );
};

export { RTLContext, RTLProvider };
